import { render, staticRenderFns } from "./AromaPayResult.vue?vue&type=template&id=ba4daca4&scoped=true"
import script from "./AromaPayResult.vue?vue&type=script&lang=js"
export * from "./AromaPayResult.vue?vue&type=script&lang=js"
import style0 from "./AromaPayResult.vue?vue&type=style&index=0&id=ba4daca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4daca4",
  null
  
)

export default component.exports